import { FC, useMemo } from "react";
import { useScrollToTop } from "../app/hooks/useScrollToTop";
import { useInitialize } from "../app/hooks/useInitialize";
import { useCompanies } from "../app/hooks/useCompanies";
import { useSites } from "../app/hooks/useSites";
import { useCompanySelect } from "../app/hooks/useCompanySelect";
import { useSiteSelect } from "../app/hooks/useSiteSelect";
import { useGuides } from "../visualGuides";
import { useAppSelector } from "../store";
import { TransitionLayout } from "./TransitionLayout";
import { MainLayout } from "./MainLayout";

export const AuthedLayout: FC = () => {
  const pagesStatus = useAppSelector((state) => state.pages.status);
  const companiesLength = useAppSelector(
    (state) => state.companies.companies.length,
  );
  const isUserFromOnboarding = useAppSelector((state) => state.user.onboarding);

  const showTransitionLayout = useMemo(
    () =>
      pagesStatus === "loading" ||
      pagesStatus === "idle" ||
      (isUserFromOnboarding === true && companiesLength === 0),
    [pagesStatus, isUserFromOnboarding, companiesLength],
  );
  useScrollToTop();
  useInitialize();
  useCompanies();
  useSites();
  useCompanySelect();
  useSiteSelect();
  useGuides();

  return showTransitionLayout ? <TransitionLayout /> : <MainLayout />;
};
